import { useMediaQuery } from 'react-responsive';
import { useSelector } from 'react-redux';
import { AgeDataChart } from './age-data-chart';
import 'chart.js/auto';
import { AppState } from 'store/store';
import { SubsectionDataChart } from './subsection-data-chart';
import { SectionDataChart } from './section-data-chart';
import { SectionRatingsAverageReport } from './section-ratings-average-report';
import { PerformanceSatisfactionChangesReport } from './performance-satisfaction-changes-report';
import { MkfPrefixMentionsReport } from './mkf-prefix-mentions-report';
import { MkfDomainMentionsReport } from './mkf-domain-mentions-report';
import { GenderPerRegionChart } from './gender-per-region';
import { TITLE } from './constants';
import { StatisticReport } from './statistic-report';
import styles from './styles.module.scss';

export const Charts = () => {
	const isMobile = useMediaQuery({ query: '(max-width: 515px)' });

	const user = useSelector((state: AppState) => state.userState.user);

	const role = user?.role;

	// @ts-ignore
	return (
		<div className={styles.charts}>
			{isMobile ? (
				<div className={styles.charts__title}>
					<h2>{TITLE}</h2>
				</div>
			) : (
				<h2>{TITLE}</h2>
			)}
			<div>
				<AgeDataChart />
			</div>
			<div>
				<SectionDataChart />
			</div>
			<div>
				<SubsectionDataChart />
			</div>
			<div>
				<SectionRatingsAverageReport />
			</div>
			<div>
				<PerformanceSatisfactionChangesReport role={role} />
			</div>
			<div>
				<MkfPrefixMentionsReport />
			</div>
			<div>
				<MkfDomainMentionsReport />
			</div>
			<div>
				<GenderPerRegionChart />
			</div>
			<div>
				<StatisticReport />
			</div>
		</div>
	);
};
